import service from './service';

export default {
  // 获取充值vip选项列表
  getVipList() {
    return service.get('/api/v1/vip/mealList');
  },
  getOrderIndex() {
    return service.get('/api/v1/company/order/index');
  },
  getOrderRechargeList(data) {
    return service({
      url: '/api/v1/company/money/recharge/log',
      method: 'get',
      params: {
        pageIndex: data.pageIndex,
        pageSize: data.pageSize
      }
    });
  },
  getOrderPayLogList(data) {
    return service({
      url: '/api/v1/company/money/pay/log',
      method: 'get',
      params: {
        pageIndex: data.pageIndex,
        pageSize: data.pageSize
      }
    });
  },
  // VIP充值订单
  getMealList(data) {
    return service({
      url: '/api/v1/company/meal/order/list',
      method: 'get',
      params: {
        pageIndex: data.pageIndex,
        pageSize: data.pageSize
      }
    });
  },
  recoveryVip() {
    return service.post('/api/v1/company/vip/recovery');
  },
  stopVip() {
    return service.post('/api/v1/company/vip/stop');
  },
  buyMoney(params) {
    return service.post('/api/v1/company/money/buy', params);
  },
  buyResume(params) {
    return service.post('/api/v1/company/buy/viewresume/count', params);
  },
  buyVipMeal(params) {
    return service.post('/api/v1/company/meal/buy', params);
  },
  getVipOrder(params) {
    return service.post('/api/v1/company/meal/order', params);
  },
  getOrderStatus(params) {
    return service.get(`/api/v1/company/meal/order/status/${params}`);
  },
  // 获取简历夹的日志
  getResumeClipLog(data) {
    return service({
      url: '/api/v1/company/resume-clip-log/list',
      method: 'get',
      params: {
        pageIndex: data.pageIndex,
        pageSize: data.pageSize
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/enterprise-order.js